export const tiles = [
    [0,6,6,6,5,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,],
    [0,0,0,0,0,0,1,0,0,0,0,0,0,0,0,0,1,0,0,6,],
    [6,0,0,0,0,0,0,0,0,0,0,0,1,0,0,0,0,0,1,6,],
    [5,0,0,0,6,0,0,0,0,5,6,0,0,0,0,0,1,0,0,6,],
    [6,0,0,0,0,0,1,0,0,0,0,0,1,0,0,0,1,0,0,6,],
    [6,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,],
    [6,0,0,0,0,0,0,0,5,0,0,0,1,0,0,0,0,0,1,6,],
    [5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,6,],
    [5,0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,1,6,],
    [6,6,6,5,6,6,6,5,6,5,6,5,5,6,6,6,6,6,6,6,]

]
